const voices = [
  {
    name: "经常刷资讯的策划",
    role: "阅读 8 个月",
    text: "别的地方只有结论，这里有过程。同一件事它会把时间线排出来，谁在什么时候做了什么，看完基本能自己判断。",
  },
  {
    name: "某品牌市场从业者",
    role: "阅读 1 年",
    text: "招商政策那几条对我挺有用，写得不夸张，反而更容易看懂行业里正在发生什么变化。",
  },
  {
    name: "内容行业观察者",
    role: "阅读 5 个月",
    text: "用词克制是加分项。涉及主体的部分基本用泛指，不会为了流量直接点名，这点在同类站点里不多见。",
  },
];

const promises = [
  { icon: "ri-links-line", title: "双信源交叉", desc: "关键信息至少两个独立来源佐证" },
  { icon: "ri-time-line", title: "时间线还原", desc: "把事件节点按发生顺序梳理清楚" },
  { icon: "ri-shield-check-line", title: "克制表达", desc: "未证实内容明确标注，不作定论" },
  { icon: "ri-refresh-line", title: "持续跟进", desc: "有进展就更新，不做一次性标题" },
];

export default function CredibilitySection() {
  return (
    <section className="bg-background-100/70 py-14 md:py-16">
      <div className="container-editorial">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-[0.18em] text-primary-600 uppercase">
              <span className="h-px w-6 bg-primary-500" />
              How We Work
            </span>
            <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-[28px]">
              小道消息也要讲基本法
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              内幕内容最容易失真，所以我们给自己定了四条底线。哪怕跑得慢一点，也要保证你看到的东西经得起回头再看。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {promises.map((item) => (
                <div key={item.title} className="rounded-lg border border-background-200/80 bg-background-50 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
              {voices.map((voice, index) => (
                <figure
                  key={voice.name}
                  className="flex h-full flex-col rounded-lg border border-background-200/80 bg-background-50 p-5 animate-fade-up"
                  style={{ animationDelay: `${index * 80}ms` }}
                >
                  <i className="ri-double-quotes-l text-2xl text-accent-500" />
                  <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                    {voice.text}
                  </blockquote>
                  <figcaption className="mt-4 border-t border-background-200 pt-3">
                    <span className="block text-sm font-medium text-foreground-950">{voice.name}</span>
                    <span className="mt-0.5 block text-xs text-foreground-500">{voice.role}</span>
                  </figcaption>
                </figure>
              ))}
            </div>

            <div className="mt-4 grid grid-cols-2 gap-4 rounded-lg border border-background-200/80 bg-background-50 p-5 sm:grid-cols-4">
              {[
                { value: "98%", label: "线索完成率" },
                { value: "12h", label: "平均跟进速度" },
                { value: "36", label: "合作信源" },
                { value: "0", label: "未经核实结论" },
              ].map((item) => (
                <div key={item.label} className="text-center">
                  <p className="font-heading text-2xl font-black text-primary-600">{item.value}</p>
                  <p className="mt-1 text-xs text-foreground-500">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}